<div class="main-container">
  <div class="page-header">
    <div class="routing-buttons">
      <div
        class="action-button back-button"
        (click)="navigateBack()"
        tabindex="0"
        (keydown.enter)="navigateBack()"
      >
        <mat-icon class="icon back-icon">arrow_back</mat-icon>
      </div>
      <div
        class="action-button reload-button"
        (click)="resetPage()"
        tabindex="0"
        (keydown.enter)="resetPage()"
      >
        <mat-icon class="icon reload-icon">refresh</mat-icon>
      </div>
      <span class="page-title">Sensorise SIM Data Details</span>
    </div>
    <div class="button-group">
      <button
        type="button"
        class="primary-button"
        [disabled]=""
        (click)="openManualIccidPage()"
      >
        Manual Upload <mat-icon class="btn-icon">open_in_new</mat-icon>
      </button>
    </div>
  </div>

  @if (isUploadBoxVisible) {
    <div class="component-container">
      <form [formGroup]="sensoriseSimDataDetailsForm" novalidate>
        <div class="component-header">
          <h6 class="component-title">SIM Data Details</h6>
          <div class="component-actions">
            <button
              class="primary-button"
              type="button"
              (click)="downloadMyFile()"
            >
              Download Sample<mat-icon class="btn-icon">download</mat-icon>
            </button>
          </div>
        </div>
        <!-- Separator between Header and Body -->
        <div class="component-separator"></div>
        <div class="component-body">
          <div class="form-section">
            <div class="form-group">
              <label for="file" class="form-label"
                >Upload ICCID's to get SIM Data Details</label
              >
              <mat-form-field
                class="file-upload-container"
                appearance="outline"
              >
                <mat-label>Upload Device ICCID's</mat-label>

                <!-- Display File Name or Placeholder -->
                <input matInput type="text" formControlName="file" readonly />

                <!-- Hidden File Input -->
                <input
                  type="file"
                  accept=".xls,.xlsx"
                  aria-label="File"
                  class="d-none"
                  (change)="onFileChange($event)"
                  #fileInput
                />

                <!-- Custom Upload Button -->
                <button
                  mat-button
                  class="upload-btn"
                  (click)="fileInput.click()"
                  type="button"
                >
                  <mat-icon>attach_file</mat-icon>
                </button>

                @if (
                  sensoriseSimDataDetailsForm.controls['file'].touched &&
                  sensoriseSimDataDetailsForm.controls['file'].errors?.required
                ) {
                  <mat-error> This field is mandatory. </mat-error>
                }
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="component-separator"></div>
        <div class="component-footer">
          <div class="button-group">
            <button
              class="submit-button"
              (click)="saveDeviceDetails()"
              [disabled]="!fileUploaded"
            >
              Submit <mat-icon class="btn-icon">check_circle</mat-icon>
            </button>
          </div>
        </div>
      </form>
    </div>
  }

  @if (!isUploadBoxVisible) {
    <!-- Uploaded Production Device List -->
    <div class="component-container">
      <div class="component-header">
        <h6 class="component-title">
          Uploaded ICCID's Sensorise SIM Details List
        </h6>
        <div class="component-actions">
          <div class="component-actions">
            <button
              class="primary-button"
              [disabled]="presentSensoriseSimDataDetails.length === 0"
              (click)="
                exportToExcelUploadedProducedDeviceData(
                  presentSensoriseSimDataDetails
                )
              "
              value="excel"
            >
              Export Uploaded Devices<mat-icon class="btn-icon"
                >download</mat-icon
              >
            </button>
          </div>
        </div>
      </div>
      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>
      <!-- Component Body Section -->
      <div class="component-body">
        <table>
          <thead>
            <tr>
              <th>ICCID</th>
              <th>Card State</th>
              <th>Card Status</th>
              <th>Primary TSP</th>
              <th>Fallback TSP</th>
              <th>Primary Status</th>
              <th>Primary MSISDN</th>
              <th>Fallback Status</th>
              <th>Fallback MSISDN</th>
              <th>Active Profiles</th>
              <th>Card Expiry Date</th>
              <th>Product Name</th>
              <th>Is RSU Required</th>
              <th>Is IMSI Required</th>
              <th>Active SR Number</th>
            </tr>
          </thead>
          @if (presentSensoriseSimDataDetails.length > 0) {
            <tbody>
              @for (
                item of presentSensoriseSimDataDetails
                  | paginate
                    : {
                        id: 'paginateUpload',
                        itemsPerPage: productionUploadedDeviceSize,
                        currentPage: productionUploadedDevicePage,
                        totalItems: presentSensoriseSimDataDetails.length,
                      };
                track item
              ) {
                <tr>
                  <td>{{ item.iccid }}</td>
                  <td>{{ item.cardState }}</td>
                  <td>{{ item.cardStatus }}</td>
                  <td>{{ item.primaryTSP }}</td>
                  <td>{{ item.fallbackTSP }}</td>
                  <td>{{ item.primaryStatus }}</td>
                  <td>{{ item.primaryMSISDN }}</td>
                  <td>{{ item.fallbackStatus }}</td>
                  <td>{{ item.fallbackMSISDN }}</td>
                  <td>{{ item.activeProfiles }}</td>
                  <td>{{ item.cardExpiryDate }}</td>
                  <td>{{ item.productName }}</td>
                  <td>{{ item.isRSURequired }}</td>
                  <td>{{ item.isIMSIRequired }}</td>
                  <td>{{ item.activeSRNumber }}</td>
                </tr>
              }
            </tbody>
          } @else {
            <tbody>
              <tr>
                <td colspan="15">
                  <img
                    loading="lazy"
                    class="no-data-img"
                    src="../../assets/dataNotFound.jpg"
                    alt="No Data Found"
                  />
                </td>
              </tr>
            </tbody>
          }
        </table>
      </div>
      <div class="component-separator"></div>
      <div class="component-footer">
        @if (presentSensoriseSimDataDetails.length > 0) {
          <app-common-component-pagination
            [totalItems]="presentSensoriseSimDataDetails.length"
            [pageSize]="productionUploadedDeviceSize"
            [currentPage]="productionUploadedDevicePage"
            (pageChange)="onPageChangeSensoriseDataNotPresentList($event)"
            (sizeChange)="onSizeChangeSensoriseDataNotPresentList($event)"
          >
          </app-common-component-pagination>
        }
      </div>
    </div>

    <!-- Duplicate Device List -->
    <div class="component-container">
      <div class="component-header">
        <h6 class="component-title">
          Duplicate ICCID's In Uploaded Excel Sheet
        </h6>
        <div class="component-actions">
          <div class="component-actions">
            <button
              class="primary-button"
              [disabled]="excelDuplicateIccidDetails.length === 0"
              (click)="
                exportToExcelDuplicateProducedDeviceData(
                  excelDuplicateIccidDetails
                )
              "
              value="excel"
            >
              Export Duplicate ICCID's<mat-icon class="btn-icon"
                >download</mat-icon
              >
            </button>
          </div>
        </div>
      </div>
      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>
      <!-- Component Body Section -->
      <div class="component-body">
        <table>
          <thead>
            <tr>
              <th>ICCID</th>
              <th>Message</th>
            </tr>
          </thead>
          @if (excelDuplicateIccidDetails.length > 0) {
            <tbody>
              @for (
                item of excelDuplicateIccidDetails
                  | paginate
                    : {
                        id: 'batchPaginateproductionDuplicateDeviceList',
                        itemsPerPage: productionDuplicateDeviceSize,
                        currentPage: productionDuplicateDevicePage,
                        totalItems: excelDuplicateIccidDetails.length,
                      };
                track item
              ) {
                <tr>
                  <td>{{ item.iccid }}</td>
                  <td>{{ item.errors }}</td>
                </tr>
              }
            </tbody>
          } @else {
            <tbody>
              <tr>
                <td colspan="5">
                  <img
                    loading="lazy"
                    class="no-data-img"
                    src="../../assets/dataNotFound.jpg"
                    alt="No Data Found"
                  />
                </td>
              </tr>
            </tbody>
          }
        </table>
      </div>
      <div class="component-separator"></div>
      <div class="component-footer">
        @if (excelDuplicateIccidDetails.length > 0) {
          <app-common-component-pagination
            [totalItems]="excelDuplicateIccidDetails.length"
            [pageSize]="productionDuplicateDeviceSize"
            [currentPage]="productionDuplicateDevicePage"
            (pageChange)="onPageChangeExcelDuplicateIccidList($event)"
            (sizeChange)="onSizeChangeExcelDuplicateIccidList($event)"
          >
          </app-common-component-pagination>
        }
      </div>
    </div>

    <!-- Invalid Device List -->
    <div class="component-container">
      <div class="component-header">
        <h6 class="component-title">
          ICCID's Not Present In Sensorise Database
        </h6>
        <div class="component-actions">
          <div class="component-actions">
            <button
              class="primary-button"
              [disabled]="iccidNotPresentInSensoriseDatabase.length === 0"
              (click)="
                exportToExcelInvalidProducedDeviceData(
                  iccidNotPresentInSensoriseDatabase
                )
              "
              value="excel"
            >
              Export ICCID Not Present<mat-icon class="btn-icon"
                >download</mat-icon
              >
            </button>
          </div>
        </div>
      </div>
      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>
      <!-- Component Body Section -->
      <div class="component-body">
        <table>
          <thead>
            <tr>
              <th>ICCID</th>
              <th>Message</th>
            </tr>
          </thead>
          @if (iccidNotPresentInSensoriseDatabase.length > 0) {
            <tbody>
              @for (
                item of iccidNotPresentInSensoriseDatabase
                  | paginate
                    : {
                        id: 'paginateInvalid',
                        itemsPerPage: productionInvalidDeviceSize,
                        currentPage: productionInvalidDevicePage,
                        totalItems: iccidNotPresentInSensoriseDatabase.length,
                      };
                track item
              ) {
                <tr>
                  <td>{{ item.iccid }}</td>
                  <td>{{ item.message }}</td>
                </tr>
              }
            </tbody>
          } @else {
            <tbody>
              <tr>
                <td colspan="5">
                  <img
                    loading="lazy"
                    class="no-data-img"
                    src="../../assets/dataNotFound.jpg"
                    alt="No Data Found"
                  />
                </td>
              </tr>
            </tbody>
          }
        </table>
      </div>
      <div class="component-separator"></div>
      <div class="component-footer">
        @if (iccidNotPresentInSensoriseDatabase.length > 0) {
          <app-common-component-pagination
            [totalItems]="iccidNotPresentInSensoriseDatabase.length"
            [pageSize]="productionInvalidDeviceSize"
            [currentPage]="productionInvalidDevicePage"
            (pageChange)="onPageChangeSensoriseDataNotPresentList($event)"
            (sizeChange)="onSizeChangeSensoriseDataNotPresentList($event)"
          >
          </app-common-component-pagination>
        }
      </div>
    </div>
  }
</div>
